export default "__VITE_ASSET__CpDdNoLH__"